import React, { useContext } from "react";
import { URL_BASE } from "../../../App";
import MyContext from "../../../StoreContext";

/**
 * Componente que muestra el screenshot del canal whatsapp y usa el contexto
 * para saber cuando cambiar la imagen a la imagen de respuesta
 */
const Whatsapp = () => {
  const { industry, channel, message, showResponse } = useContext(MyContext);

  if (message) {
    return (
      <img
        src={`${URL_BASE}/${industry}/${channel}/${
          !showResponse ? message : message + "_response"
        }.webp`}
        alt='whatsapp'
        className='phoneDimension'
      />
    );
  }

  return (
    <img
      src={`${URL_BASE}/${industry}/${channel}/${channel}_base.webp`}
      alt='whatsapp'
      className='phoneDimension'
    />
  );
};

export default Whatsapp;
